import React, { useState } from 'react';
import AiMessagePrompt from './AiMessagePrompt';

const IconTrigger = () => {
    const [isOpen, setIsOpen] = useState(false);
    const closeModal = () => setIsOpen(false);

    return (
        <div>
            <button
                type="button"
                id="ai-icon"
                className="btn btn--primary-alt"
                title="AI Message Drafting"
                onClick={() => setIsOpen(!isOpen)}
            >
                <i className="far fa-magic" aria-hidden="true"></i>
                <span className="btn__tooltip ai-message-tooltip shift-left btn__tooltip--up bg-blue-48 font-white">
          AI Message Drafting
                </span>
            </button>
            <AiMessagePrompt isOpen={isOpen} onClose={closeModal} />
        </div>
    );
};

export default IconTrigger;
